<template>
	<div class="dl_main">
		<div class="dl_head">
			<img src="../assets/logo.png" />
			<div><span class="t">芝麻招工</span></div>
			<span class="b" @click="copyText">打开</span>
		</div>
		<!-- <img class="dl_logo" src="../assets/logo.png" /> -->
		<div class="dl_title">芝麻招工</div>
		<!-- <img class="dl_phone" src="../assets/show.png" /> -->
		<!-- <div v-if="isAndroid">
			<div  @click="copyText">
				<div class="dl_download">立即下载</div>
			</div>
		</div>
		<div v-else> -->
		<div>
			<template v-if="isWeixin">
			<wx-open-launch-app
				id="launch-btn"
				class="launch-btn"
				:appid="'wx996226744f71bd1f'"
				:extinfo="extinfo"
				>
				<!-- <slot>
					<div class="btn"><div class="dl_download">立即下载</div></div>
				</slot> -->
				<script type="text/wxtag-template">
						<button class="btn" style="width: 200px;
							height: 45px;
							background: #2D67F6;
							border-radius: 45px;
							color: #fff;
							font-size: 16px;
							font-weight: 500;
							margin-top: 10px;
							line-height: 45px;
							text-align: center;">App内查看</button>
					</script>
			</wx-open-launch-app>
			</template>
			<template v-else>
				<div @click="launch">
					<div class="dl_download">立即下载</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import wx from 'weixin-js-sdk'
	export default {
		data() {
			return {
				code: null,
				sdkinfo: '',
				enable: '',
				extinfo: 'ruguimingxiang://page?param1=1&param2=2',
				isWeixin: false,
				isAndroid: false,
				isIOS: false
			}
		},
		mounted() {
			/////
			var btn = document.getElementById('launch-btn')
			    btn.addEventListener('launch', e => {
			        // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
			        console.log('success');
							this.setClipboard()
			    });
			    btn.addEventListener('error', e => {
			        // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
			        console.log('fail', e.detail);
							const de = e.detail
							let str = ''
							for(var key in de) {
								str += 'Key:' + key + de[key]
							}
							alert(str)
							this.copyText()
			        // 唤醒失败的情况下，可用于降级处理比如在此处跳转到应用宝
			    });
			//const that = this
			//setTimeout(() => {
			//	that.$refs.copy.click()
			//}, 800)
		},
		created() {
			this.code = this.$route.query.code
			let u = navigator.userAgent;
			this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
			this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
			this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
			if(this.isWeixin){
			  this.getSdk()
			}
		},
		methods: {
			getSdk(){
				// let code =  this.$route.query.code
				console.log(location.href)
				let obj = {
					"url": location.href //"https://qingfeng.fit/#"+ this.$route.path +"/?code=" + this.$route.query.code
				}
				axios.post("https://api.ruguo.cc/api/wechat/jssdk/config",obj,{
				  headers:{
				      "Content-Type":"application/json"
				  }
				}).then(res=>{
				    if(res.data.ret === 0){
				      this.sdkinfo = res.data.data
							console.log('===============', this.sdkinfo)
					  	this.extinfo = "ruguimingxiang://page?param1=1&param2=2"
							wx.config({
								debug: false,
								appId: this.sdkinfo.appid,
								timestamp: this.sdkinfo.timestamp,
								nonceStr: this.sdkinfo.noncestr,
								signature: this.sdkinfo.sign,
								jsApiList: [
									"onMenuShareTimeline", // 分享到朋友圈
								],
								openTagList: ['wx-open-launch-app']
							})
				    }
				    // console.log(res)
				})
			},
			copyText() {
				this.$copyText(this.code).then(e => {
				    window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.taijizen.qf')
				}, function(e) {
					// alert('复制失败')
					console.log('复制失败')
				})
			},
			setClipboard(){
				this.$copyText(this.code)
			},
			launch(){
			  this.setClipboard()
			  if(!this.isWeixin){
			    this.copyText()
			  }
			}
		}
	}
</script>

<style>
	.dl_main {
		/* background: url(../assets/background.png) no-repeat; */
		background-size: 100% 100%;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.dl_head {
		display: flex;
		align-items: center;
		background: #000;
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		padding: 12px;
	}

	.dl_head img {
		width: 40px;
		margin-right: 15px;
	}

	.dl_head div .t {
		font-size: 14px;
		font-weight: bold;
		margin-right: 10px;
		color: white;
	}

	.dl_head div .s {
		font-size: 12px;
		olor: white;
	}

	.dl_head .b {
		width: 70px;
		height: 32px;
		background: #F8931F;
		border-radius: 32px;
		text-align: center;
		line-height: 32px;
		margin-left: auto;
		font-size: 14px;
	}

	.dl_logo {
		width: 3.75rem;
		margin-left: 0;
	}

	.dl_title {
		font-size: 1.0625rem;
		margin: 20px 0 10px 0;
		font-weight: bold;
		color: #333;
	}

	.dl_slogan {
		font-weight: 14px;
		color: #333;
	}

	.dl_phone {
		width: 10.1875rem;
		margin-top: 30px;
	}

	.dl_download {
		width: 200px;
		height: 45px;
		background: #2D67F6;
		border-radius: 45px;
		color: #fff;
		font-size: 16px;
		font-weight: 500;
		margin-top: 10px;
		line-height: 45px;
		text-align: center;
	}
</style>
